import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, Typography, Tag, Button, Row, Col, Space, message } from 'antd';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { userReportActionStart, userReportActionError, getUserReportAction } from '../../core/data/redux/modules/userReport/actions';
import { getUserReportById } from '../../services/adminServices/userReport';

const { Title, Paragraph, Text } = Typography;

const UserReportDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { report, loading } = useSelector((state: any) => state.userReport || { report: null, loading: false });
  const [localReport, setLocalReport] = useState<any>(null);

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line
  }, [id]);

  const fetchReport = async () => {
    dispatch(userReportActionStart());
    try {
      const res = await getUserReportById(id!);
      if (res.error) throw new Error(res.message);
      dispatch(getUserReportAction(res.data));
      setLocalReport(res.data);
    } catch (err: any) {
      dispatch(userReportActionError(err.message));
      message.error(err.message);
    }
  };

  if (loading || !localReport) return <Card loading style={{ margin: 24 }} />;

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>User Report Details</Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Title level={5}>Report Information</Title>
              <Paragraph><Text strong>ID:</Text> {localReport.id}</Paragraph>
              <Paragraph><Text strong>Reported User:</Text> {localReport.reported_user}</Paragraph>
              <Paragraph><Text strong>Reason:</Text> {localReport.reason}</Paragraph>
              <Paragraph><Text strong>Status:</Text> <Tag color={localReport.status === 'open' ? 'orange' : 'green'}>{localReport.status}</Tag></Paragraph>
              <Paragraph><Text strong>Details:</Text> {localReport.details}</Paragraph>
            </Col>
          </Row>
          <Space style={{ marginTop: 32 }}>
            <Link to="/admin/user-report/list-user-reports">
              <Button>Back to List</Button>
            </Link>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default UserReportDetail; 